module.exports = __webpack_public_path__ + "img/theater.b41a31b9.svg";